import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";

import useFcm from "../hooks/useFcmToken";
import FcmService from "../services/Fcm";

const FcmContext = createContext(null);

export const FcmProvider = ({ children }) => {
 const isLoggedIn = useSelector((state) => state.login.token);
const { fcmToken } = useFcm(Boolean(isLoggedIn));

  const [pendingDeviceId, setPendingDeviceId] = useState(null);
  const registeringRef = useRef(false);

  const registerDevice = (deviceId) => {
    setPendingDeviceId(deviceId);
  };

  useEffect(() => {
    if (!fcmToken || !pendingDeviceId || registeringRef.current) return;

    const saveToken = async () => {
      registeringRef.current = true;

      try {
        await FcmService.PushToken({
          push_token: fcmToken,
          device_id: pendingDeviceId,
        });
      } catch (error) {
        console.error("Register device failed:", error);
      } finally {
        registeringRef.current = false;
        setPendingDeviceId(null);
      }
    };

    saveToken();
  }, [fcmToken, pendingDeviceId]);

  return (
    <FcmContext.Provider value={{ registerDevice }}>
      {children}
    </FcmContext.Provider>
  );
};

export const useFcmContext = () => {
  const context = useContext(FcmContext);

  if (!context) {
    throw new Error("useFcmContext must be used inside FcmProvider");
  }

  return context;
};